import {
  FilterId,
  FilterOptionsType,
  MultiSelectListFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import { DisputeStatus } from 'uplisting-frontend/models/dispute';

export class DisputeStatusFilter extends MultiSelectListFilter {
  id = FilterId.disputeStatus;
  optionsType = FilterOptionsType.list;
  optionsList = Object.values(DisputeStatus);
}
